const cartaoContinenteErrorHTML = (data = {}) => {
    const { error = true, helpLink } = data;
    const noAvailableCouponsMsg = document.querySelector(".js-customer-benefits").getAttribute("data-no-available-coupons");
    const cartaoContinenteText = document.querySelector(".js-resources").getAttribute("data-cartao-continente");
    const serviceErrorMsg = document.querySelector(".js-customer-benefits").getAttribute("data-service-error");
    const errorText = error ? serviceErrorMsg.split(".") : noAvailableCouponsMsg;
    const cartaoContinenteImg = document.querySelector(".js-cartao-continente-img").getAttribute("data-url");
    let errorContentHTML = "";
    let benefitsErrorSectionHTML = "";

    if (error) {
        errorContentHTML =
        `
            <span>${errorText[0] + "."}</span>
            <a class="js-benefits-service-error-help-link pwc-anchor" href="${helpLink}">${errorText[1]}</a>
        `;
    } else {
        errorContentHTML = `<span>${errorText}</span>`;
    }

    benefitsErrorSectionHTML =
    `
        <div class="nocupons w-100">
            <div class="benefits-service-error-card-icon ${error ? "" : "benefits-no-coupons"}">
                <img
                    src="${cartaoContinenteImg}"
                    alt="${cartaoContinenteText}"
                />
            </div>
            <div class="benefits-service-error-message d-flex flex-column align-items-start justify-content-center">
                ${errorContentHTML}
            </div>
        </div>
    `;

    //GTM logic - Start
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": false,
            "messageContent": errorText
        }
    }));
    //GTM logic - End

    return benefitsErrorSectionHTML;
};

export { cartaoContinenteErrorHTML };
